import nextTick from 'next-tick';
import { createBrowserHistory } from 'history';
import ParamsParser from '@synergycms_core/utils/paramsParser';
import { is, reject, isEmpty } from 'ramda';
import { hashSpliter, hashOnly, removeHash } from '../utils';

//A function that creates a middleware that functions as a "router" that maps urls to actions or actionCreators
export const history = createBrowserHistory();
export default function router(routeResolver, opts) {
  let options = {
    fireInitial: true,
    urlChangeActionType: 'ROUTER/UPDATE',
    urlErrorActionType: 'ROUTER/ERROR',
    urlChangeActionProperty: 'hash',
    queryChangeActionProperty: 'search',
    defaultMatchAction: '',
    ...opts
  };

  
  history.location.state = null;

  const middleware = ({ dispatch, getState }) => {
    function actionToUrl(location, action) {
      const newHash = is(Array, location.hash) ? reject(isEmpty, location.hash).join('/') : location.hash;
      const hash = hashOnly(history.location.hash);

      const newQuery = location.search;
      const query = removeHash(history.location.search);

      //TODO fer q la regular expresion rebenti l'interrogant
      if ((newHash && newHash !== hash) || (newQuery && '?' + newQuery !== query)) {
        const finalQuery = location.search ? location.search : removeHash(history.location.search);
        const finalHash = newHash ? newHash : hashOnly(history.location.hash);
        const finalPathName = location.pathname ? location.pathname : history.location.pathname;

        const newRoute = {
          pathname: finalPathName,
          search: finalQuery,
          hash: finalHash,
          state: 'from_action'
        };

        if (action === 'replace') {
          history.replace(newRoute);
        } else {
          history.push(newRoute);
        }
      }
    }
    window.availEngine = window.availEngine || {};
    window.availEngine.onChangeAvailUrl = function(location, action) {
      if (action === 'ENGINE') {
        actionToUrl(location, 'push');
      }

      if (action === 'REPLACE' || action === 'POP' || action === undefined || action === 'ENGINE') {
        const hashArray = hashSpliter(location.hash);
        const objParams = ParamsParser.urlToParams(location.search);
        routeResolver(hashArray, objParams)(dispatch, getState);
        //....
      }
    };

    //s'hauria de verificar q no hi hagin listeners ja creats i netejarlos
    history.listen(window.availEngine.onChangeAvailUrl);

    if (options.fireInitial) {
      nextTick(() => {
        window.availEngine.onChangeAvailUrl(history.location);
      });
    }

    return next => action => {
      //Run the action, then change the URL if we had one that matched.

      if (action.type === options.urlChangeActionType || action.type === options.urlErrorActionType) {
        let newRoute;
        if (action && action.payload && typeof action.payload === 'function') {
          const result = action.payload(dispatch, getState, hashSpliter(history.location.hash));
          if (result && result.then) {
            return result
              .then(result => {
                newRoute = result;
              })
              .catch(err => {
                console.log(err);
              });
          } else {
            if (result) {
              newRoute = result;
            }
          }
        } else {
          newRoute = action.payload;
        }
        if (newRoute) {
          actionToUrl(newRoute, newRoute.action);
        }
        action.payload = newRoute;
        return next(action);
      }
      return next(action);
    };
  };

  return middleware;
}
